import { useEffect, useRef } from 'react';
import { mapSocketFactory } from '../utils/socketFactory'; // Adjust path as needed

export const useHaloSocket = (avatarId, onHaloLevel) => {
    // Keep a ref to the callback to prevent effect re-runs if the function changes
    const callbackRef = useRef(onHaloLevel);

    useEffect(() => {
        callbackRef.current = onHaloLevel;
    }, [onHaloLevel]);

    useEffect(() => {
        if (!avatarId) return;

        const eventName = `haloLevel-${avatarId}`;
        let checkInterval = null;

        // Stable handler calling the latest ref
        const handleSocketData = (data) => {
            if (data?.level !== undefined) {
                callbackRef.current(data.level);
            }
        };

        // Retry Logic
        const trySubscribe = () => {
            if (mapSocketFactory && mapSocketFactory.socket && mapSocketFactory.socket.connected) {
                mapSocketFactory.socket.on(eventName, handleSocketData);
                if (checkInterval) clearInterval(checkInterval);
                return true;
            }
            return false;
        };

        // Attempt 1: Immediate
        if (!trySubscribe()) {
            // Attempt 2: Interval
            checkInterval = setInterval(trySubscribe, 500);
        }

        // Cleanup
        return () => {
            if (checkInterval) clearInterval(checkInterval);
            if (mapSocketFactory?.socket) {
                mapSocketFactory.socket.off(eventName, handleSocketData);
            }
        };
    }, [avatarId]);
};